(function () {
  if (window.__doctorVideoSliderInit) return;
    window.__doctorVideoSliderInit = true;

  // 한 영상이 재생되면 같은 슬라이더의 다른 영상은 일시정지 (재생 위치 유지)
  document.addEventListener('play', function (e) {
    var video = e.target;
    if (!(video instanceof HTMLVideoElement)) return;
    var slider = video.closest('.doctor-video-slider');
    if (!slider) return;
    slider.querySelectorAll('video').forEach(function (v) {
      if (v !== video && !v.paused) v.pause();
    });
  }, true);

  // 영상 하단 컨트롤 바(진행 바·볼륨)를 조작할 때는 슬라이드가 움직이지 않게
  var CONTROL_ZONE = 56;
  document.addEventListener('pointerdown', function (e) {
    var video = e.target.closest && e.target.closest('.doctor-video-slider video');
    if (!video) return;
    if (e.clientY > video.getBoundingClientRect().bottom - CONTROL_ZONE) {
      video.classList.add('swiper-no-swiping');
    }
  }, true);
  function clearNoSwipe() {
    document.querySelectorAll('.doctor-video-slider video.swiper-no-swiping').forEach(function (v) {
      v.classList.remove('swiper-no-swiping');
    });
  }
  document.addEventListener('pointerup', clearNoSwipe, true);
  document.addEventListener('pointercancel', clearNoSwipe, true);

  function init(root) {
    if (typeof Swiper === 'undefined') return;
    root.querySelectorAll('.doctor-video-slider').forEach(function (slider) {
      if (slider.dataset.swiperReady) return;
      var el = slider.querySelector('.video-slider__swiper');
      if (!el) return;
      slider.dataset.swiperReady = 'true';

      new Swiper(el, {
        slidesPerView: 2.7,
        spaceBetween: 12,
        grabCursor: true,
        watchOverflow: true,
        threshold: 6,
        touchStartPreventDefault: false,
        navigation: {
          prevEl: slider.querySelector('.video-slider__arrow--prev'),
          nextEl: slider.querySelector('.video-slider__arrow--next'),
          disabledClass: 'is-disabled'
        },
        scrollbar: {
          el: slider.querySelector('.video-slider__scrollbar'),
          draggable: true,
          hide: false
        },
        on: {
          init: function () {
            var sw = this;
            requestAnimationFrame(function () {
              if (sw.scrollbar) sw.scrollbar.updateSize();
            });
          },
          resize: function () {
            if (this.scrollbar) this.scrollbar.updateSize();
          }
        },
        breakpoints: {
          990: { slidesPerView: 3 }
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // 테마 편집기에서 섹션이 다시 그려질 때 재초기화
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();